/*
 *
 * QuestionnairePage constants
 *
 */
import * as PROPERTIES from 'data/nodeProperties';
import * as PROPERTIES_ANSWER from 'data/answerProperties';
import { getSurveyLocationResetExceptionRules } from 'containers/SurveyPage/constants';
export const FETCH_QUESTIONNAIRE = 'app/QuestionnairePage/FETCH_QUESTIONNAIRE';
export const FETCH_QUESTIONNAIRE_SUCCESS =
  'app/QuestionnairePage/FETCH_QUESTIONNAIRE_SUCCESS';
export const FETCH_QUESTIONNAIRE_ERROR =
  'app/QuestionnairePage/FETCH_QUESTIONNAIRE_ERROR';

export const UPDATE_QUESTIONNAIRE =
  'app/QuestionnairePage/UPDATE_QUESTIONNAIRE';

export const UPDATE_QUESTIONNAIRE_LOGIC =
  'app/QuestionnairePage/UPDATE_QUESTIONNAIRE_LOGIC';

export const STORE_QUESTIONNAIRE = 'app/QuestionnairePage/STORE_QUESTIONNAIRE';
export const STORE_QUESTIONNAIRE_ERROR =
  'app/QuestionnairePage/STORE_QUESTIONNAIRE_ERROR';
export const STORE_QUESTIONNAIRE_SUCCESS =
  'app/QuestionnairePage/STORE_QUESTIONNAIRE_SUCCESS';

export const STORE_QUESTIONNAIRE_TEXTS =
  'app/QuestionnairePage/STORE_QUESTIONNAIRE_TEXTS';
export const STORE_QUESTIONNAIRE_TEXTS_ERROR =
  'app/QuestionnairePage/STORE_QUESTIONNAIRE_TEXTS_ERROR';
export const STORE_QUESTIONNAIRE_TEXTS_SUCCESS =
  'app/QuestionnairePage/STORE_QUESTIONNAIRE_TEXTS_SUCCESS';

export const STORE_DISQUALIFICATION_RULES =
  'app/QuestionnairePage/STORE_DISQUALIFICATION_RULES';
export const STORE_DISQUALIFICATION_RULES_ERROR =
  'app/QuestionnairePage/STORE_DISQUALIFICATION_RULES_ERROR';
export const STORE_DISQUALIFICATION_RULES_SUCCESS =
  'app/QuestionnairePage/STORE_DISQUALIFICATION_RULES_SUCCESS';

export const ADD_QUESTION_TO_QUESTIONNAIRE =
  'app/QuestionnairePage/ADD_QUESTION_TO_QUESTIONNAIRE';
export const REMOVE_QUESTION_FROM_QUESTIONNAIRE =
  'app/QuestionnairePage/REMOVE_QUESTION_FROM_QUESTIONNAIRE';
export const COPY_QUESTION_FROM_QUESTIONNAIRE =
  'app/QuestionnairePage/COPY_QUESTION_FROM_QUESTIONNAIRE';

export const UPDATE_VALIDATION_ERRORS =
  'app/QuestionnairePage/UPDATE_VALIDATION_ERRORS';
export const UPDATE_QUESTION_FAVORITE_STATE =
  'app/QuestionnairePage/UPDATE_QUESTION_FAVORITE_STATE';

export const SET_ACTIVE_NODE = 'app/QuestionnairePage/SET_ACTIVE_NODE';
export const MOVE_QUESTION = 'app/QuestionnairePage/MOVE_QUESTION';
export const UPDATE_GROUP_PROPERTIES =
  'app/QuestionnairePage/UPDATE_GROUP_PROPERTIES';
export const SET_QUESTIONNAIRE_SHUFFLING =
  'app/QuestionnairePage/SET_QUESTIONNAIRE_SHUFFLING';

export const SHOW_ALL_ERRORS = 'app/QuestionnairePage/SHOW_ALL_ERRORS';

export const SHOW_MOVE_QUESTION_MODAL =
  'app/QuestionnairePage/SHOW_MOVE_QUESTION_MODAL';
export const CLOSE_MOVE_QUESTION_MODAL =
  'app/QuestionnairePage/CLOSE_MOVE_QUESTION_MODAL';
export const INSERT_RECALL = 'app/QuestionnairePage/INSERT_RECALL';

export const MOVE_NODE = 'app/QuestionnairePage/MOVE_NODE';
export const MOVE_NODES_TO_GROUP = 'app/QuestionnairePage/MOVE_NODES_TO_GROUP';
export const REMOVE_GROUP_KEEP_NODES =
  'app/QuestionnairePage/REMOVE_GROUP_KEEP_NODES';

export const TOGGLE_MODAL = 'app/QuestionnairePage/TOGGLE_MODAL';

export const FETCH_QUESTIONNAIRE_DIFF = `app/QuestionnairePage/FETCH_QUESTIONNAIRE_DIFF`;
export const FETCH_QUESTIONNAIRE_DIFF_SUCCESS = `app/QuestionnairePage/FETCH_QUESTIONNAIRE_DIFF`;

// QUESTIONNAIRE REVISIONS
export const SET_REVISION_PREVIEW_MODE =
  'app/QuestionnairePage/revisions/SET_REVISION_PREVIEW_MODE';
export const SET_REVISION_PREVIEW_MODE_SUCCESS =
  'app/QuestionnairePage/revisions/SET_REVISION_PREVIEW_MODE_SUCCESS';

export const FETCH_QUESTIONNAIRE_REVISIONS =
  'app/QuestionnairePage/revisions/FETCH_QUESTIONNAIRE_REVISIONS';
export const FETCH_QUESTIONNAIRE_REVISIONS_SUCCESS =
  'app/QuestionnairePage/revisions/FETCH_QUESTIONNAIRE_REVISIONS_SUCCESS';
export const FETCH_QUESTIONNAIRE_REVISIONS_ERROR =
  'app/QuestionnairePage/revisions/FETCH_QUESTIONNAIRE_REVISIONS_ERROR';

export const FETCH_QUESTIONNAIRE_BY_REVISION =
  'app/QuestionnairePage/revisions/FETCH_QUESTIONNAIRE_BY_REVISION';
export const LOAD_QUESTIONNAIRE_REVISION =
  'app/QuestionnairePage/revisions/LOAD_QUESTIONNAIRE_REVISION'; // FETCH_QUESTIONNAIRE_BY_REVISION_SUCCESS
export const FETCH_QUESTIONNAIRE_BY_REVISION_ERROR =
  'app/QuestionnairePage/revisions/FETCH_QUESTIONNAIRE_BY_REVISION_ERROR';

export const RENAME_QUESTIONNAIRE_REVISION =
  'app/QuestionnairePage/revisions/RENAME_QUESTIONNAIRE_REVISION';
export const RENAME_QUESTIONNAIRE_REVISION_SUCCESS =
  'app/QuestionnairePage/revisions/RENAME_QUESTIONNAIRE_REVISION_SUCCESS';
export const RENAME_QUESTIONNAIRE_REVISION_ERROR =
  'app/QuestionnairePage/revisions/RENAME_QUESTIONNAIRE_REVISION_ERROR';
export const SAVE_QUESTIONNAIRE_REVISION =
  'app/QuestionnairePage/revisions/SAVE_QUESTIONNAIRE_REVISION';
export const SAVE_QUESTIONNAIRE_REVISION_SUCCESS =
  'app/QuestionnairePage/revisions/SAVE_QUESTIONNAIRE_REVISION_SUCCESS';
export const SAVE_QUESTIONNAIRE_REVISION_ERROR =
  'app/QuestionnairePage/revisions/SAVE_QUESTIONNAIRE_REVISION_ERROR';

export const DELETE_QUESTIONNAIRE_REVISION =
  'app/QuestionnairePage/revisions/DELETE_QUESTIONNAIRE_REVISION';
export const DELETE_QUESTIONNAIRE_REVISION_SUCCESS =
  'app/QuestionnairePage/revisions/DELETE_QUESTIONNAIRE_REVISION_SUCCESS';
export const DELETE_QUESTIONNAIRE_REVISION_ERROR =
  'app/QuestionnairePage/revisions/DELETE_QUESTIONNAIRE_REVISION_ERROR';

export const RESTORE_QUESTIONNAIRE_REVISION =
  'app/QuestionnairePage/revisions/RESTORE_QUESTIONNAIRE_REVISION';

export const REVERT_QUESTIONNAIRE_REVISION_LATEST_AI = `app/QuestionnairePage/revisions/REVERT_QUESTIONNAIRE_REVISION_LATEST_AI`;
export const REVERT_QUESTIONNAIRE_REVISION_LATEST_AI_SUCCESS = `app/QuestionnairePage/revisions/REVERT_QUESTIONNAIRE_REVISION_LATEST_AI_SUCCESS`;
export const REVERT_QUESTIONNAIRE_REVISION_LATEST_AI_ERROR = `app/QuestionnairePage/revisions/REVERT_QUESTIONNAIRE_REVISION_LATEST_AI_ERROR`;

export const AB_ADD_CONCEPT = 'app/QuestionnairePage/AB_ADD_CONCEPT';
export const AB_UPDATE_CONCEPT = 'app/QuestionnairePage/AB_UPDATE_CONCEPT';
export const AB_REMOVE_CONCEPT = 'app/QuestionnairePage/AB_REMOVE_CONCEPT';
export const GROUP_ADD_ATTRIBUTE = 'app/QuestionnairePage/GROUP_ADD_ATTRIBUTE';
export const GROUP_ADD_CONCEPT = 'app/QuestionnairePage/GROUP_ADD_CONCEPT';
export const GROUP_UPDATE_ATTRIBUTE =
  'app/QuestionnairePage/GROUP_UPDATE_ATTRIBUTE';
export const GROUP_REMOVE_ATTRIBUTE =
  'app/QuestionnairePage/GROUP_REMOVE_ATTRIBUTE';
export const GROUP_REMOVE_LOOP_AND_MERGE_CONCEPT =
  'app/QuestionnairePage/GROUP_REMOVE_LOOP_AND_MERGE_CONCEPT';
export const GROUP_RE_ORDER_LOOP_AND_MERGE_CONCEPT =
  'app/QuestionnairePage/GROUP_RE_ORDER_LOOP_AND_MERGE_CONCEPT';
export const GROUP_UPDATE_ATTRIBUTE_VALUE =
  'app/QuestionnairePage/GROUP_UPDATE_ATTRIBUTE_VALUE';
export const AB_ADD_DEFAULT_NODES =
  'app/QuestionnairePage/AB_ADD_DEFAULT_NODES';
export const AB_UPDATE_PROPERTIES =
  'app/QuestionnairePage/AB_UPDATE_PROPERTIES';
export const FETCH_DEMOGRAPHICS = 'app/QuestionnairePage/FETCH_DEMOGRAPHICS';
export const FETCH_DEMOGRAPHICS_SUCCESS =
  'app/QuestionnairePage/FETCH_DEMOGRAPHICS_SUCCESS';
export const FETCH_DEMOGRAPHICS_ERROR =
  'app/QuestionnairePage/FETCH_DEMOGRAPHICS_ERROR';
export const CONJOINT_UPDATE_PROPERTIES =
  'app/QuestionnairePage/CONJOINT_UPDATE_PROPERTIES';
export const DOE_UPDATE_GROUP_AND_PROPERTIES =
  'app/QuestionnairePage/DOE_UPDATE_GROUP_AND_PROPERTIES';
export const CONJOINT_MOVE_ATTRIBUTE =
  'app/QuestionnairePage/CONJOINT_MOVE_ATTRIBUTE';
export const VAN_WESTENDORP_UPDATE_SETTINGS =
  'app/QuestionnairePage/VAN_WESTENDORP_UPDATE_SETTINGS';
export const VAN_WESTENDORP_UPDATE_LIKELIHOOD =
  'app/QuestionnairePage/VAN_WESTENDORP_UPDATE_LIKELIHOOD';
export const MATRIX_OPEN_ENDED_UPDATE_SETTINGS =
  'app/QuestionnairePage/MATRIX_OPEN_ENDED_UPDATE_SETTINGS';

export const FETCH_DESIGN_OF_EXPERIMENT =
  'app/QuestionnairePage/FETCH_DESIGN_OF_EXPERIMENT';
export const FETCH_DESIGN_OF_EXPERIMENT_SUCCESS =
  'app/QuestionnairePage/FETCH_DESIGN_OF_EXPERIMENT_SUCCESS';
export const FETCH_DESIGN_OF_EXPERIMENT_ERROR =
  'app/QuestionnairePage/FETCH_DESIGN_OF_EXPERIMENT_ERROR';

export const DUPLICATE_MULTIPLE_QUESTIONS_TO_QUESTIONNAIRE =
  'app/QuestionnairePage/DUPLICATE_MULTIPLE_QUESTIONS_TO_QUESTIONNAIRE';

export const UPDATE_QUESTIONNAIRE_EXTERNAL =
  'app/QuestionnairePage/UPDATE_QUESTIONNAIRE_EXTERNAL';

export const CLEAR_EXTERNAL_UPSERT_ADDITIONAL_INFO =
  'app/QuestionnairePage/CLEAR_EXTERNAL_UPSERT_ADDITIONAL_INFO';

export const LOOP_AND_MERGE_UPDATE_GROUP =
  'app/QuestionnairePage/LOOP_AND_MERGE_UPDATE_GROUP';

export const LOOP_AND_MERGE_UPDATE_GROUP_SUCCESS =
  'app/QuestionnairePage/LOOP_AND_MERGE_UPDATE_GROUP_SUCCESS';

export const LOOP_AND_MERGE_UPDATE_PROPERTIES =
  'app/QuestionnairePage/LOOP_AND_MERGE_UPDATE_PROPERTIES';

// non-update actions
export const TOGGLE_QUESTION_COLLAPSE =
  'app/QuestionnairePage/TOGGLE_QUESTION_COLLAPSE';

export const ADD_NODE = 'app/QuestionnairePage/ADD_NODE';
export const TOGGLE_NODE_VISIBILITY =
  'app/QuestionnairePage/TOGGLE_NODE_VISIBILITY';
export const VALIDATE_ALL_NODES = 'app/QuestionnairePage/VALIDATE_ALL_NODES';

// Quota actions
export const SET_NODE_QUOTA_MODE = 'app/QuestionnairePage/SET_NODE_QUOTA_MODE';
export const TOGGLE_NODE_QUOTAS_SUCCESS =
  'app/QuestionnairePage/TOGGLE_NODE_QUOTAS_SUCCESS';
export const TOGGLE_NODE_QUOTAS_ERROR =
  'app/QuestionnairePage/TOGGLE_NODE_QUOTAS_ERROR';
export const CREATE_NODE_QUOTA_RULES =
  'app/QuestionnairePage/CREATE_NODE_QUOTA_RULES';
export const REMOVE_NODE_QUOTA_RULES =
  'app/QuestionnairePage/REMOVE_NODE_QUOTA_RULES';
export const UPDATE_NODE_QUOTA_RULE_VALUE =
  'app/QuestionnairePage/UPDATE_NODE_QUOTA_RULE_VALUE';

// Screening actions
export const SET_ANSWER_SCREENER_TYPE =
  'app/QuestionnairePage/SET_ANSWER_SCREENER_TYPE';
export const RESET_SCREENER_TYPES =
  'app/QuestionnairePage/RESET_SCREENER_TYPES';

export const ERROR_TYPES = {
  NONE: 'NONE',
  NOT_FEASIBLE: 'NOT_FEASIBLE',
  QUESTIONNAIRE_VALIDATION: 'QUESTIONNAIRE_VALIDATION',
  MANDATORY_COMMENTS: 'MANDATORY_COMMENTS',
  QUESTIONS_OVERFLOW: 'QUESTIONS_OVERFLOW',
  QUESTIONNAIRE_CIRCLES: 'QUESTIONNAIRE_CIRCLES',
  NON_INCLUDED_QUESTIONS: 'NON_INCLUDED_QUESTIONS',
  WRONG_CONTEXT_REFERENCE: 'WRONG_CONTEXT_REFERENCE',
  HIDDEN_ANSWER_REFERENCE: 'HIDDEN_ANSWER_REFERENCE',
  CONJOINT_VALIDATION: 'CONJOINT_VALIDATION',
  THIRD_PARTY_VALIDATION: 'THIRD_PARTY_VALIDATION',

  TARGETING_VALIDATION: 'TARGETING_VALIDATION',
  LINK_SETTINGS_VALIDATION: 'LINK_SETTINGS_VALIDATION',
  SCREENING_QUESTIONS_EXCEED_MAX_LIMIT: 'SCREENING_QUESTIONS_EXCEED_MAX_LIMIT',
  HIDDEN_VARIABLES: 'HIDDEN_VARIABLES',
  NON_VISIBLE_QUESTIONS: 'NON_VISIBLE_QUESTIONS',
};

export const REORDER_DIRECTION_DOWN = 0;
export const REORDER_DIRECTION_UP = 1;

export const SLIDER_DEFAULT_MIN = 0;
export const SLIDER_DEFAULT_MAX = 100;
export const SLIDER_DEFAULT_STEP = 1;
export const SLIDER_ALLOWED_MIN = -1000000;
export const SLIDER_ALLOWED_MAX = 1000000;

export const QUESTION_PROMPT_MAX_LENGTH = 1200;
export const QUESTION_DESCRIPTION_PROMPT_MAX_LENGTH = 3000;
export const ANSWER_MAX_LENGTH = 600;
export const AB_ATTRIBUTE_TEXT_MAX_LENGTH = 1200;

export const RENAME_SLIDER_QUESTION_PROPERTIES = [
  {
    source: 'slideQuestionDto.slideQuestionId',
    target: 'slideQuestionDto.id',
  },
  { source: 'slideQuestionDto', target: 'slider' },
];

export const ANSWER_DEFAULT = 0;
export const ANSWER_OTHER = 1;
export const ANSWER_NONE_OF_THE_ABOVE = 2;

export const MIN_ANSWER_LIMIT = 1;

export const MAX_ANSWER_LIMIT = 100;
export const MAX_RANKING_ANSWER_LIMIT = 10;

export const MIN_DECIMALS_LIMIT = 1;
export const MAX_DECIMALS_LIMIT = 4;

const PRISTINE_TYPES = {
  PROMPT: 'isPristinePrompt',
  ANSWERS: 'isPristineAnswers',
  COLUMNS: 'isPristineColumns',
  ROWS: 'isPristineRows',
  LIMITS: 'isPristineLimits',
  RANGE: 'isPristineRange',
  ATTRIBUTES: 'isPristineAttributes',
  ATTRIBUTE_VALUES: 'isPristineAttributeValues',
  VARIABLES: 'isPristineVariables',
  REPETITIONS: 'isPristineRepetitions',
};

export const ERROR_MAP = {
  missingPrompt: PRISTINE_TYPES.PROMPT,
  questionTooLong: PRISTINE_TYPES.PROMPT,
  missingAnswers: PRISTINE_TYPES.ANSWERS,
  missingTicks: PRISTINE_TYPES.ANSWERS,
  emptyAnswers: PRISTINE_TYPES.ANSWERS,
  answerTooLong: PRISTINE_TYPES.ANSWERS,
  emptyRows: PRISTINE_TYPES.ROWS,
  emptyColumns: PRISTINE_TYPES.COLUMNS,
  tickTooLong: PRISTINE_TYPES.ANSWERS,
  sliderMissingValues: PRISTINE_TYPES.ANSWERS,
  limitMissingValues: PRISTINE_TYPES.LIMITS,
  minMaxRangeInvalid: PRISTINE_TYPES.LIMITS,
  outOfLimitsRows: PRISTINE_TYPES.ROWS,
  outOfLimitsColumns: PRISTINE_TYPES.COLUMNS,
  emptyScalepointLabels: PRISTINE_TYPES.COLUMNS,
  emptyRankingLow: PRISTINE_TYPES.RANGE,
  emptyRankingHigh: PRISTINE_TYPES.RANGE,
  emptyAttributeContent: PRISTINE_TYPES.ATTRIBUTES,
  emptyAttributeValues: PRISTINE_TYPES.ATTRIBUTE_VALUES,
  repetitionsBiggerThanConceptsLength: PRISTINE_TYPES.REPETITIONS,
  limitMaxSmaller: PRISTINE_TYPES.LIMITS,
  decimalsInvalid: PRISTINE_TYPES.RANGE,
  decimalsZero: PRISTINE_TYPES.RANGE,
  missingVariables: PRISTINE_TYPES.VARIABLES,
};

export const PROMPT_REDUNDANT_WORDS_AGE = ['age', 'old', 'born'];
export const PROMPT_REDUNDANT_WORDS_GENDER = ['gender', 'male', 'female'];
export const PROMPT_REDUNDANT_WORDS_DEMOGRAPHICS = [
  'marital status',
  'income',
  'education',
  'race',
  'children',
  'employment status',
  'area of employment',
];
export const PROMPT_REDUNDANT_WORDS_PII = ['email', 'e-mail', 'address'];
export const PROMPT_REDUNDANT_WORDS_OTHER = 'other';
export const PROMPT_REDUNDANT_WORDS_NONE_OF_THE_ABOVE = 'none of the above';

export const QUESTION_LIMIT = 100;
export const QUESTION_LIMIT_DISTRIBUTION_LINK = 150;

export const npsOptions = [
  {
    value: 0,
    label: '0',
  },
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3',
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 6,
    label: '6',
  },
  {
    value: 7,
    label: '7',
  },
  {
    value: 8,
    label: '8',
  },
  {
    value: 9,
    label: '9',
  },
  {
    value: 10,
    label: '10',
  },
];

export const MOVE_DIRECTION = {
  UP: -1,
  DOWN: 1,
};

export const MODALS = {
  MOVE_NODES: 1,
  REMOVE_GROUP: 2,
  CONCEPTS_ADD_ASSET: 3,
  VW_ADD_ASSET: 4,
};

export const LOGIC_MODES = {
  PLAIN: 'PLAIN',
  DISQUALIFICATION: 'DISQUALIFICATION',
  HIDDEN_VARIABLES: 'HIDDEN_VARIABLES',
  DISPLAY_LOGIC: 'DISPLAY_LOGIC',
  ADVANCED_QUOTA_LOGIC: 'ADVANCED_QUOTA_LOGIC',
};

export const LOGIC_MODE_KEYS = {
  PLAIN: 'questionnaireLogic',
  DISQUALIFICATION: 'disqualificationLogic',
  HIDDEN_VARIABLES: 'questionnaireLogic',
  DISPLAY_LOGIC: 'questionnaireLogic',
  ADVANCED_QUOTA_LOGIC: 'questionnaireLogic',
};

export const DISQUALIFY_PLACEHOLDER_QUESTION = {
  id: '-1',
  refId: '-1',
  answers: [],
  nodes: [],
};

const crosstabs = '/survey/:id/cross-tabs';
const crosstab = '/survey/:id/cross-tabs/:crosstabId';
const crosstabPreview = '/survey/:id/cross-tabs/:crosstabId/preview';
const translations = '/survey/translations/:id';

export const locationResetExceptionRoutes = [
  ...getSurveyLocationResetExceptionRules(),

  { fromStartsWith: crosstabs, toStartsWith: crosstabs },
  { fromStartsWith: crosstab, toStartsWith: crosstabs },
  { fromStartsWith: crosstab, toStartsWith: crosstabPreview },
  { fromStartsWith: crosstabPreview, toStartsWith: crosstab },
  { fromStartsWith: crosstabPreview, toStartsWith: crosstab },
  { fromStartsWith: translations, toStartsWith: translations },
];

export const QUESTIONNAIRE_SUBSTATE_PATHS = [
  'surveyDetailsExtended.ql',
  'surveyDetailsExtended.disqualificationRules',
  'surveyDetailsExtended.isPeeq',
  'surveyDetailsExtended.isDistributionLink',
  'surveyDetailsExtended.surveyConfig',
  'errors',
  'questionnaireLogic',
  'isQuestionnairePreview',
  'surveyDetailsExtended.questions',
  'surveyDetailsExtended.questionGroups',
  'surveyDetailsExtended.lang',
  'surveyDetailsExtended.theme',
  'surveyDetailsExtended.questionGroupShuffle',
  'hiddenVariables',
];

export const QUESTIONNAIRE_DEFAULT_SUBSTATE_PATHS_TO_OMIT = [
  'errors',
  'questionnaireLogic',
];

export const CONFIRM_MODAL_TYPES = {
  CHANGE_QUESTION_THAT_CF: 'CHANGE_QUESTION_THAT_CF',
  CHANGE_QUESTION_WITH_CF: 'CHANGE_QUESTION_WITH_CF',
  CHANGE_QUESTION_WITH_LOOP_AND_MERGE: 'CHANGE_QUESTION_WITH_LOOP_AND_MERGE',
  CHANGE_QUESTION_WITH_CF_AND_LOOP_AND_MERGE:
    'CHANGE_QUESTION_WITH_CF_AND_LOOP_AND_MERGE',
};

export const CONFIRM_MODAL_DATA_TEST_ID = {
  [CONFIRM_MODAL_TYPES.CHANGE_QUESTION_THAT_CF]: {
    modal: 'confirm-modal-change-question-that-cf',
    okButton: 'confirm-modal-change-question-that-cf-ok-button',
    cancelButton: 'confirm-modal-change-question-that-cf-cancel-button',
  },
  [CONFIRM_MODAL_TYPES.CHANGE_QUESTION_WITH_CF]: {
    modal: 'confirm-modal-change-question-with-cf',
    okButton: 'confirm-modal-change-question-with-cf-ok-button',
    cancelButton: 'confirm-modal-change-question-with-cf-cancel-button',
  },
  [CONFIRM_MODAL_TYPES.CHANGE_QUESTION_WITH_LOOP_AND_MERGE]: {
    modal: 'confirm-modal-change-question-with-loop-and-merge',
    okButton: 'confirm-modal-change-question-with-loop-and-merge-ok-button',
    cancelButton:
      'confirm-modal-change-question-with-loop-and-merge-cancel-button',
  },
  [CONFIRM_MODAL_TYPES.CHANGE_QUESTION_WITH_CF_AND_LOOP_AND_MERGE]: {
    modal: 'confirm-modal-change-question-with-cf-and-loop-and-merge',
    okButton:
      'confirm-modal-change-question-with-cf-and-loop-and-merge-ok-button',
    cancelButton:
      'confirm-modal-change-question-with-cf-and-loop-and-merge-cancel-button',
  },
};

export const ADD_QUESTION_DIRECTION = {
  INSERT_ABOVE: 0,
  INSERT_BELOW: 1,
};

export const translationPropertiesForMentions = [
  PROPERTIES.PROPERTY_QUESTION_INDEX,
  PROPERTIES.PROPERTY_PROMPT,
  PROPERTIES.PROPERTY_PROMPT_ORIGIN,
  PROPERTIES.PROPERTY_TYPE,
  PROPERTIES.PROPERTY_TRANSLATED_REF_ID,
  PROPERTIES.PROPERTY_IS_GOOGLE_TRANSLATED,
  PROPERTIES.PROPERTY_HAS_PIPING,
  PROPERTIES.PROPERTY_ANSWERS,
  PROPERTIES.PROPERTY_SCOREPOINTS,
  'matrix.columns',
  PROPERTIES.PROPERTY_GROUP_REF_ID,
  PROPERTIES.PROPERTY_REF_ID,
  PROPERTIES.PROPERTY_LABEL,
  PROPERTIES.PROPERTY_SHUFFLE,
  PROPERTIES.PROPERTY_IS_SCREENING,
];

export const translationPropertiesForMentionsLoop = [
  PROPERTIES.PROPERTY_QUESTION_INDEX,
  PROPERTIES.PROPERTY_PROMPT,
  PROPERTIES.PROPERTY_PROMPT_ORIGIN,
  PROPERTIES.PROPERTY_TYPE,
  PROPERTIES.PROPERTY_TRANSLATED_REF_ID,
  PROPERTIES.PROPERTY_IS_GOOGLE_TRANSLATED,
  PROPERTIES.PROPERTY_HAS_PIPING,
  PROPERTIES.PROPERTY_ANSWERS,
  PROPERTIES.PROPERTY_SCOREPOINTS,
  'matrix.columns',
  PROPERTIES.PROPERTY_GROUP_REF_ID,
  PROPERTIES.PROPERTY_REF_ID,
  PROPERTIES.PROPERTY_LABEL,
  PROPERTIES.PROPERTY_SHUFFLE,
  PROPERTIES.PROPERTY_IS_SCREENING,
];

export const nodePropertiesForMentions = [
  PROPERTIES.PROPERTY_QUESTION_INDEX,
  PROPERTIES.PROPERTY_PROMPT,
  PROPERTIES.PROPERTY_TYPE,
  PROPERTIES.PROPERTY_LABEL,
  PROPERTIES.PROPERTY_GROUP_REF_ID,
  PROPERTIES.PROPERTY_REF_ID,
  PROPERTIES.PROPERTY_SHUFFLE,
  PROPERTIES.PROPERTY_DISPLAY_SAME_PAGE,
  PROPERTIES.PROPERTY_ANSWERS,
  PROPERTIES.PROPERTY_MATRIX,
  PROPERTIES.PROPERTY_IS_SCREENING,
];

export const nodePropertiesWithPrompt = [
  PROPERTIES.PROPERTY_ANSWERS,
  PROPERTIES.PROPERTY_SCOREPOINTS,
  {
    name: PROPERTIES.PROPERTY_MATRIX,
    values: [
      PROPERTIES.PROPERTY_MATRIX_COLUMNS,
      PROPERTIES.PROPERTY_MATRIX_ANSWERS,
      PROPERTIES.PROPERTY_MATRIX_EXTRA_LABELS,
    ],
  },
];

export const answerPromptProperties = [
  PROPERTIES_ANSWER.PROPERTY_BODY,
  PROPERTIES_ANSWER.PROPERTY_LABEL,
  PROPERTIES_ANSWER.PROPERTY_LABEL_BEFORE,
  PROPERTIES_ANSWER.PROPERTY_LABEL_AFTER,
];

export const MAX_PIPED_QUESTION_LENGTH = 24;

export const OPTION_TYPES = {
  ANSWER: 'ANSWER',
  COLUMN: 'COLUMN',
  ROW: 'ROW',
  NODE: 'NODE',
  LABEL: 'LABEL',
};

// question answer action types
export const QA_ACTION_TYPES = {
  BUTTON: 'BUTTON',
  BUTTON_WITH_TEXT: 'BUTTON_WITH_TEXT',
};
